<template>
  <div class="Details"
       :style="listHeight">
    <el-scrollbar style="height:100%;">
      <el-row class="content">
        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title">
              <span class="Asterisk">*</span>任务名称:
            </div>
          </el-col>
          <el-col :span="21"
                  class="blueConent">{{task.TASKNAME}}</el-col>
        </el-row>
        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">
              <span class="Asterisk">*</span>联系人:
            </div>
          </el-col>
          <el-col :span="21"
                  class="blackConent">{{detail.LINKMANNAME}}</el-col>
        </el-row>
        <el-row class="rowContent"
                v-if="detail.EVENTTYPENAME=='故障报修'">
          <el-col :span="3">
            <div class="title">
              <span class="Asterisk">*</span>故障地址:
            </div>
          </el-col>
          <el-col :span="21"
                  class="blueConent">{{detail.LINKADDRESS}}</el-col>
        </el-row>
      </el-row>
      <el-row class="content interval">
        <el-row class="rowContent">
          <el-col :span="3">
            <div class="title size14">
              <span class="Asterisk">*</span>内容描述:
            </div>
          </el-col>
          <el-col :span="21"
                  class="blackConent">
            <div v-html="taskContent.CONTENT"></div>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="content interval">
        <el-row class="rowContent">
          <el-col :span="3">
            <div class="title size14">
              <span class="Asterisk">*</span>完成描述:
            </div>
          </el-col>
          <el-col :span="21"
                  class="blackConent">
            <div v-html="taskContent.EXCUTEUSERREPLY"></div>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="content interval">
        <el-row class="rowContent">
          <el-col :span="3">
            <div class="title size14">
              <span class="Asterisk">*</span>附件:
            </div>
          </el-col>
          <el-col :span="21"
                  class="blackConent">
            <div v-for="file in fileList"
                 :key="file.ID"
                 class="fileposition">
              <div class="filetitle cursor"
                   @click="fileView(file.FILEPATH)">{{file.FILENAME}}</div>
              <a class="filecontent blackConent cursor underline"
                 @click="download(file.ID)">下载</a>
            </div>
          </el-col>
        </el-row>
      </el-row>
      <el-row class="content interval">
        <el-row class="rowContent line">
          <el-col :span="24">
            <div class="title size14">
              <span class="Asterisk">*</span>工作记录:
            </div>
          </el-col>
        </el-row>
        <el-row class="rowContent1 timeline">
          <!-- <el-steps direction="vertical title size14" :active="1">
                                        <el-step :title="createTimeFormat(step.CREATETIME)" v-for="(step,index) in RecordList" :key="index">
                                            <template slot="description">
                                                        <div class="jobDetails">
                                                            <el-row>
                                                                {{step.NAME}}
                                                            </el-row>
                                                            <el-row class="blackConent1">
                                                               [创建人:{{step.CREATEUSERNAME}}]&nbsp;
                                                               [记录编号:{{step.INSTANCE}}]&nbsp;
                                                               {{typeName(step)}}
                                                            </el-row>

                                                            <el-row>
                                                                <div v-html="step.INFO"></div>
                                                            </el-row>
                                                        </div>
</template>
                        </el-step>
          </el-steps>-->
          <el-timeline>
            <el-timeline-item :timestamp="createTimeFormat(step.CREATETIME)"
                              color="#2b7cff"
                              placement="top"
                              v-for="(step,index) in RecordList"
                              :key="index">
              <el-card>
                <h4 class="blueConent size14">{{step.NAME}}</h4>
                <p class="blackConent2">[创建人:{{step.CREATEUSERNAME}}]&nbsp;[记录编号:{{step.INSTANCE}}]&nbsp;{{typeName(step)}}</p>
                <p class="blackConent1"
                   v-html="step.INFO"></p>
              </el-card>
            </el-timeline-item>
            <!-- <el-timeline-item timestamp="2018/4/3" placement="top">
      <el-card>
        <h4>更新 Github 模板</h4>
        <p>王小虎 提交于 2018/4/3 20:46</p>
      </el-card>
    </el-timeline-item>
    <el-timeline-item timestamp="2018/4/2" placement="top">
      <el-card>
        <h4>更新 Github 模板</h4>
        <p>王小虎 提交于 2018/4/2 20:46</p>
      </el-card>
            </el-timeline-item>-->
          </el-timeline>
        </el-row>
      </el-row>
      <el-row class="content interval rowContent Other">
        <!-- <el-row class="rowContent "> -->
        <div @click="More">
          <span>其他详细信息</span>
          <i :class="isShow?'el-icon-caret-top':'el-icon-caret-bottom'"></i>
        </div>
        <!-- </el-row> -->
      </el-row>
      <el-row v-show="isShow"
              class="content interval">
        <el-row class="rowContent line">
          <!-- <el-col :span="3">
            <div class="title size14">事件单号:</div>
          </el-col>
          <el-col :span="5" class="orangeConent size14">{{task.EVENTINSTANCE}}</el-col>-->
          <el-col :span="3">
            <div class="title size14">任务单号:</div>
          </el-col>
          <el-col :span="5"
                  class="orangeConent size14">{{task.INSTANCE}}</el-col>
          <el-col :span="3">
            <div class="title size14">执行状态:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent size14">
            <div :class="task.STATE|taskStateFormater"
                 style="float:left;margin-top:12px;margin-right:5px;"></div>
            <div style="float:left;">{{task.TASKSTATENAME}}</div>
          </el-col>
        </el-row>
        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">上报来源:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent">{{task.CREATESOURCE|createSourceFormater}}</el-col>
          <el-col :span="3">
            <div class="title size14">任务类型:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent size14">{{task.TASKTYPENAME}}</el-col>
          <el-col :span="3">
            <div class="title size14">任务等级:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent size14">{{task.TASKDEGREE|taskDegreeFormater }}</el-col>
        </el-row>

        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">组织名称:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent">{{detail.CUSTOMERDEPTNAME||'&nbsp;'}}</el-col>
          <el-col :span="3">
            <div class="title size14">服务台:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent size14">{{task.SERVERCENTERNAME}}</el-col>
          <el-col :span="3">
            <div class="title size14">关注度:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent size14">{{task.FOCUSDEGREE|focusDegreeFormater}}</el-col>
        </el-row>
        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">创建时间:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1">{{task.CREATETIME|timeFormater}}</el-col>
          <el-col :span="3">
            <div class="title size14">接收时间:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1 size14">{{task.ACCEPTTIME|timeFormater}}</el-col>
          <el-col :span="3">
            <div class="title size14">完成时间:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1 size14">{{task.COMPLETTIME|timeFormater}}</el-col>
        </el-row>
        <el-row class="rowContent line"
                v-if="detail.EVENTTYPENAME=='故障报修'">
          <el-col :span="3">
            <div class="title size14">故障设备:</div>
          </el-col>
          <el-col :span="5">
            <div class="title size14">{{formatting(detail.DeviceList, true)}}</div>
            <!-- <div class="title size14">{{detail.DeviceList[0].NAME}}</div> -->
          </el-col>
          <el-col :span="3">
            <div class="title size14">故障类型:</div>
          </el-col>
          <el-col :span="5">
            <div class="title size14">{{formatting(detail.FaultTypeList, false)}}</div>
          </el-col>
        </el-row>
        <el-row class="rowContent line"
                v-if="detail.EVENTTYPENAME!='故障报修'">
          <el-col :span="3">
            <div class="title size14">任务地址:</div>
          </el-col>
          <el-col :span="21"
                  class="blackConent1 size14">{{detail.LINKADDRESS}}</el-col>
        </el-row>
        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">预计开始时间:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1">{{taskDetail.BEGINDATE|timeFormater}}</el-col>
          <el-col :span="3">
            <div class="title size14">预计完成时间:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1 size14">{{taskDetail.ENDDATE|timeFormater}}</el-col>
          <el-col :span="3">
            <div class="title">进度逾期时间：</div>
          </el-col>
          <el-col :span="5">{{(taskDetail.OVERTIME||'').replace('T',' ').substr(0,19)}}</el-col>
        </el-row>
        <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">接收时长:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1">{{notice(taskDetail.FIRSTRESPONSENUM,taskDetail.FIRSTRESPONSEUNIT)}}</el-col>
          <el-col :span="3">
            <div class="title size14">超期提醒周期:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1 size14">{{notice(taskDetail.RESPONSENUM,taskDetail.RESPONSEUNIT)}}</el-col>
          <el-col :span="3">
            <div class="title">操作超期时间：</div>
          </el-col>
          <el-col :span="5">{{(taskDetail.RESPONSEENDTIME||'').replace('T',' ').substr(0,19)}}</el-col>
        </el-row>

        <!-- <el-row class="rowContent line">
          <el-col :span="3">
            <div class="title size14">预计工作量:</div>
          </el-col>
          <el-col :span="5" class="blackConent1">{{planWorkloadName}}</el-col>
          <el-col :span="3">
            <div class="title size14">实际工作量:</div>
          </el-col>
          <el-col :span="5" class="blackConent1 size14">{{actualWorkloadName}}</el-col>
        </el-row>-->
        <el-row class="rowContent bottom">
          <el-col :span="3">
            <div class="title size14">创建人:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1 size14">
            <ChatUser :userInfo="{id:task.CREATEUSERID,name:task.CREATEUSERNAME}"></ChatUser>
          </el-col>
          <el-col :span="3">
            <div class="title size14">执行人:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1">
            <ChatUser :userInfo="{id:task.EXCUTEUSERID,name:task.EXCUTEUSERNAME}"></ChatUser>
          </el-col>
          <el-col :span="3">
            <div class="title size14">报告人:</div>
          </el-col>
          <el-col :span="5"
                  class="blackConent1 size14">
            <ChatUser :userInfo="{id:task.PROPOSERID,name:task.PROPOSERNAME}"></ChatUser>
          </el-col>
        </el-row>
      </el-row>
    </el-scrollbar>
  </div>
</template>

<script>
import ChatUser from "../Chat/ChatUser.vue";
import {
  getEventByEventId,
  GetRecordInfoByMainId,
  GetFileInfoByTaskId,
  GetTaskContentByTaskId,
  getTaskByTaskId
} from "@/api/modules/basicData/task";

import { getToken } from "@/util/auth";
const cookieUser = getToken();
import { Download2 } from "@/api/modules/basicData/commonData";
export default {
  components: {
    ChatUser
  },
  data() {
    return {
      detail: {},
      RecordList: [],
      taskContent: {},
      fileList: [],
      isShow: true,
      img: require("../../../assets/img/file.png"),
      // task:{},
      taskDetail: {}
    };
  },
  mounted() {
    // 			setTimeout(() => {
    // 				console.log(this.detail,'detail');
    // 				console.log(this.task,'task');
    // 			},1000)
    // this.initalTask()
  },
  created() {
    let a = $(window).height();
    this.listHeight = "height:" + (a - 150) + "px;";
  },
  methods: {
    formatting(val, bol) {
      console.log(val);
      if (val) {
        let arr = [];
        if (bol) {
          val.forEach(c => {
            arr.push(c.NAME);
          });
        } else {
          val.forEach(c => {
            arr.push(c.FAULTTYPENAME);
          });
        }
        return arr.join(",");
      }
    },
    initalTask: function() {
      if (!this.task) return;
      getEventByEventId(this.task.ID).then(pmevent => {
        this.detail = pmevent ? pmevent : {};
      });
      GetTaskContentByTaskId(this.task.ID).then(pmevent => {
        this.taskContent = pmevent ? pmevent : {};
      });
      GetFileInfoByTaskId(this.task.ID, 100).then(file => {
        // if (!file) return;
        file.forEach(c => {
          c.ID = this.IMGAPI_ROOT + "api/Task/DownloadFileById?id=" + c.ID;
        });
        this.fileList = file;
      });
      GetRecordInfoByMainId(this.task.ID, 0).then(pmevent => {
        if (!pmevent) return;
        this.RecordList = pmevent.splice(0, 2);
      });
      getTaskByTaskId(this.task.ID, cookieUser.userId)
        .then(res => {
          this.taskDetail = res;
        })
        .catch(res => {
          console.log(res);
        });
    },
    download(url) {
      window.location.href = url;
    },
    More() {
      if (this.isShow) this.isShow = false;
      else this.isShow = true;
    },
    // 根据文件名后缀区分 文件类型
    /*
     * @param: fileName - 文件名称
     * @param: 数据返回 1) 无后缀匹配 - false
     * @param: 数据返回 2) 匹配图片 - image
     * @param: 数据返回 3) 匹配 txt - txt
     * @param: 数据返回 4) 匹配 excel - excel
     * @param: 数据返回 5) 匹配 word - word
     * @param: 数据返回 6) 匹配 pdf - pdf
     * @param: 数据返回 7) 匹配 ppt - ppt
     * @param: 数据返回 8) 匹配 视频 - video
     * @param: 数据返回 9) 匹配 音频 - radio
     * @param: 数据返回 10) 其他匹配项 - other
     */
    matchType(fileName) {
      // 后缀获取
      var suffix = "";
      // 获取类型结果
      var result = "";
      try {
        var flieArr = fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false;
        return result;
      }
      suffix = suffix.toLowerCase();
      // 图片格式
      var imglist = [
        "doc",
        "docx",
        "ppt",
        "pptx",
        "xls",
        "xlsx",
        "zip",
        "mp4",
        "mp3",
        "txt",
        "pdf",
        "png",
        "jpg",
        "jpeg",
        "bmp",
        "gif"
      ];
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix;
      });
      return result;
    },
    fileView(filepath) {
      filepath = filepath.replace(/\\/g, "/");
      if (process.env.Is_ViewApi) {
        Download2(filepath).then(res => {
          var fileurl = this.File_ROOT + res.replace(/\\/g, "/");
          var url = this.OnlinePreview + fileurl;
          var winHeight = window.document.documentElement.clientHeight - 60;
          var winWidth = window.document.documentElement.clientWidth - 100;
          window.open(
            url,
            "_blank",
            "height=" +
              winHeight +
              ",width=" +
              winWidth +
              ",top=30,left=30,toolbar=no, menubar=no, scrollbars=yes, resizable=yes"
          );
        });
      } else {
        var fileurl = this.File_ROOT + filepath;
        var url = this.OnlinePreview + fileurl;
        var winHeight = window.document.documentElement.clientHeight - 60;
        var winWidth = window.document.documentElement.clientWidth - 100;
        window.open(
          url,
          "_blank",
          "height=" +
            winHeight +
            ",width=" +
            winWidth +
            ",top=30,left=30,toolbar=no, menubar=no, scrollbars=yes, resizable=yes"
        );
      }
    },
    // 根据文件名后缀区分 文件类型
    /*
     * @param: fileName - 文件名称
     * @param: 数据返回 1) 无后缀匹配 - false
     * @param: 数据返回 2) 匹配图片 - image
     * @param: 数据返回 3) 匹配 txt - txt
     * @param: 数据返回 4) 匹配 excel - excel
     * @param: 数据返回 5) 匹配 word - word
     * @param: 数据返回 6) 匹配 pdf - pdf
     * @param: 数据返回 7) 匹配 ppt - ppt
     * @param: 数据返回 8) 匹配 视频 - video
     * @param: 数据返回 9) 匹配 音频 - radio
     * @param: 数据返回 10) 其他匹配项 - other
     */
    matchTypeImg(fileName) {
      // 后缀获取
      var suffix = "";
      // 获取类型结果
      var result = "";
      try {
        var flieArr = fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
      } catch (err) {
        suffix = "";
      }
      // fileName无后缀返回 false
      if (!suffix) {
        return require("../../../assets/img/file.png");
      }
      suffix = suffix.toLowerCase();
      // 图片格式
      var imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
      // 进行图片匹配
      result = imglist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "image";
        return this.File_ROOT + fileName.replace(/\\/g, "/");
      }
      // 匹配txt
      var txtlist = ["txt"];
      result = txtlist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        return require("../../../assets/img/file.png");
      }
      // 匹配 excel
      var excelist = ["xls", "xlsx"];
      result = excelist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "excel";
        return require("../../../assets/img/xls.png");
      }
      // 匹配 word
      var wordlist = ["doc", "docx"];
      result = wordlist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "word";
        return require("../../../assets/img/word.png");
      }
      // 匹配 pdf
      var pdflist = ["pdf"];
      result = pdflist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "pdf";
        return require("../../../assets/img/file.png");
      }
      // 匹配 ppt
      var pptlist = ["ppt"];
      result = pptlist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "ppt";
        return require("../../../assets/img/PPT.png");
      }
      // 匹配 视频
      var videolist = ["mp4", "m2v", "mkv"];
      result = videolist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "video";
        return require("../../../assets/img/video.png");
      }
      // 匹配 音频
      var radiolist = ["mp3", "wav", "wmv"];
      result = radiolist.some(function(item) {
        return item == suffix;
      });
      if (result) {
        result = "radio";
        return require("../../../assets/img/mp3.png");
      }
      // 其他 文件类型
      result = "other";
      return require("../../../assets/img/file.png");
    },
    createTimeFormat(time) {
      //格式化时间
      return time ? time.replace("T", " ").substr(0, 19) : "";
    },
    typeName: function(item) {
      const openName = item.ISOPEN ? "[公开]" : "[私人]";
      const typeName = item.RECORDTYPE === 0 ? "[个人]" : "[会议]";
      return typeName + openName;
    },
    notice(num, unit) {
      if (!num || num == 0) {
        return "";
      }
      let responseUnit = { 0: "分", 1: "小时", 2: "天" };
      return num + responseUnit[unit];
    }
  },
  computed: {
    task: function() {
      return this.$store.state.task.curTask;
    },
    tabIndex: function() {
      return this.$store.state.task.tabIndex;
    },
    // ...mapState({ task: state => state.task.curTask}),
    planWorkloadName: function() {
      if (!this.task) return "";
      return (
        this.task.PLANWORKLOAD +
        (this.task.PLANWORKLOADUNIT == 0 ? "小时" : "天")
      );
    },
    actualWorkloadName: function() {
      // Object.keys(this.task).length===0
      if (!this.task) return "";
      return (
        this.task.ACTUALWORKLOAD +
        (this.task.ACTUALWORKLOADUNIT == 0 ? "小时" : "天")
      );
    }
  },
  watch: {
    task: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    },
    tabIndex: function(newvalue) {
      if (!newvalue) return;
      this.initalTask();
    }
  },
  filters: {
    createSourceFormater: function(val) {
      switch (val) {
        case 0:
          return "PC桌面";
        case 1:
          return "微信";
        case 2:
          return "电话";
        case 3:
          return "网站";
        case 8:
          return "统一桌面";
        case 5:
          return "邮件";
        case 6:
          return "监控";
        case 7:
          return "运维APP";
        default:
          return "";
      }
    },
    taskDegreeFormater: function(val) {
      switch (val) {
        case 0:
          return "重要且紧急";
        case 1:
          return "重要不紧急";
        case 2:
          return "紧急不重要";
        case 3:
          return "不重要不紧急";
        default:
          return "";
      }
    },
    focusDegreeFormater: function(val) {
      switch (val) {
        case 1:
          return "一级关注";
        case 2:
          return "二级关注";
        case 3:
          return "三级关注";
        default:
          return "";
      }
    },
    taskStateFormater: function(val) {
      switch (val) {
        case 0:
          return "daijieshou";
        case 1:
          return "zhixingzhong";
        case 2:
          return "wancheng";
        case 3:
          return "guanbi";
        case 4:
          return "shenpizhong";
        case 5:
          return "guaqizhong";
        case -1:
          return "zuofei";
        default:
          return "guanbi";
      }
    }
  }
};
</script>
<style lang="less">
.content {
  .el-step.is-vertical .el-step__title {
    color: #4f5869;
    width: 89px;
  }
  .el-step__title .is-finish {
    float: left;
  }
  .el-step__description .is-finish {
    float: left;
  }
}
.timeline {
  .el-card__body {
    padding: 10px;
  }
}
</style>
<style scoped>
.Details .content {
  background-color: #ffffff;
  border-radius: 2px;
  margin-right: 20px;
}
.content .rowContent {
  height: 60px;
  margin: 0px 30px;
  line-height: 60px;
}
.content .rowContent1 {
  margin: 10px 30px;
}
.content .line {
  border-bottom: 1px solid #d5dae6;
}
.interval {
  margin-top: 15px;
}
.Asterisk {
  width: 8px;
  height: 8px;
  color: #ffb25f;
  margin-right: 2px;
}
.blueConent {
  font-size: 16px;
  color: #2b7cff;
}
.blackConent {
  font-size: 14px;
  color: #262b33;
}
.blackConent1 {
  font-size: 14px;
  color: #929baa;
}
.blackConent2 {
  font-size: 14px;
  color: #959ca6;
}
.orangeConent {
  color: #ffb25f;
}
.size14 {
  font-size: 14px;
}
.fileposition {
  margin: 0px 20px;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 3px 4px;
}
.title {
  text-align: left;
  font-family: MicrosoftYaHei-Bold;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #929baa;
}
.abstract {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #606266;
}
.tagtitle {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #858585;
}
.content1 {
  color: black;
  font-weight: 600;
}
.complete {
  color: black;
  font-weight: 600;
}
.fileview {
  font-size: 12px;
  font-family: Microsoft YaHei;
}
.code {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #0099ff;
}
.fileview ul {
  /*ul向div父元素右方浮动*/
  list-style: none;
  /*将默认的列表符号去掉*/
  margin: 0;
  /* 将默认的内边距去掉 */
  padding: 0px;
  /* 将默认的外边距去掉 */
}
.fileview li {
  list-style: none;
  margin: 0px 0px 10px 0px;
  /* padding: 20px 0px 30px 0px; */
  /* width: 15%; */
  /* float: left; */
  text-align: center;
  display: flex;
  /* font-size: 20px; */
  color: #5b6379;
  /* cursor: pointer; */
  /*li标签按顺序向ul父元素左方浮动*/
}
.image {
  width: 50px;
  height: 50px;
  /* border:1px solid black; */
  position: relative;
}
.filetitle {
  font-size: 14px;
  color: #2b7cff;
  float: left;
}
.filecontent {
  float: left;
  padding-left: 3px;
  padding-right: 20px;
}
.filebutton {
  margin: 10px 10px 2px 10px;
  float: left;
  cursor: pointer;
}
.cursor {
  cursor: pointer;
}
.underline {
  text-decoration: underline;
}
.Other {
  letter-spacing: 1px;
  color: #4f5869;
  font-size: 12px;
  text-align: center;
  padding: 5px 0px;
  cursor: pointer;
}
.bottom {
  margin-bottom: 530px;
}
.view {
  color: #ff9a40;
}
.download {
  color: #409eff;
}
.img {
  max-width: 50px;
  max-height: 50px;
  margin-top: auto;
  margin-bottom: auto;
  top: 0;
  left: 0;
  bottom: 0;
  position: absolute;
}
.btnName {
  width: 95%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.daiding {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/daiding.png);
}
.daijieshou {
  text-align: center;
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/daijieshou.png);
}
.shenpizhong {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/shenpizhong.png);
}
.wancheng {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/wancheng.png);
}
.zhixingzhong {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/zhixingzhong.png);
}
.zuofei {
  width: 18px;
  height: 18px;
  background: url(../../../../src/assets/img/zuofei.png);
}
.jobDetails {
  background-color: #f2f5fa;
  font-size: 14px;
}
</style>
